<refactor-card-header>
<!--Sectión generate code success-->

<!-- <div *ngIf="isProcessing" class="processing-container">
    <img src="assets/images/spinner-logo.svg" class="logo-spinner" />
    <p>Generando código...</p>
</div> -->

<div class="success-message">
    <ion-icon name="checkmark-circle-sharp" class="check-circle"></ion-icon>
    <p>¡Código generado con éxito!</p>

    <button class="show-code-button" (click)="showCode()">Ver código</button>
    <button class="download-code-button" (click)="onDownload()">
        Descargar
      </button><br>
    <a (click)="returnfileUpload()" class="return-update-file">
        Comenzar de nuevo
    </a>
</div>
</refactor-card-header>